exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".dashboard-buttons {\n  text-align: right;\n  margin-bottom: 10px;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/gcp-applications/monash-online-credit/monash-online-credit-prod@2/src/main/client/app/student/dashboard/student-dashboard.less","/var/lib/jenkins/workspace/gcp-applications/monash-online-credit/monash-online-credit-prod@2/student-dashboard.less"],"names":[],"mappings":"AAAA;EAAmB,kBAAA;EAAmB,oBAAA;CCGrC","file":"student-dashboard.less","sourcesContent":[".dashboard-buttons{text-align: right; margin-bottom: 10px;}\n",".dashboard-buttons {\n  text-align: right;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"importLoaders":1}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/main/client/app/student/dashboard/student-dashboard.less
// module id = 520
// module chunks = 0